import * as React from "react"
import { Base } from "./Base"
import { AlliedMarine } from "./AlliedMarine"

type FooterProps = {
  children?: React.ReactNode
  sticky?: boolean
  appendClassNames?: string
}

type FooterSubcomponent = {
  AlliedMarine: typeof AlliedMarine
}

const Footer: React.FC<FooterProps> & FooterSubcomponent = (props: FooterProps): React.JSX.Element => {
  return <Base {...props} />
}

Footer.AlliedMarine = AlliedMarine

export {
  Footer
}
